import React, {useRef} from "react";
import clsx from "clsx";
import {createUseStyles} from "react-jss";
import {useDimensionObserver} from "engage-client/hooks/useDimensionObserver";
import {
	LeaderboardRowHeight,
	LeaderboardRowGap,
	LeaderboardStartRowY,
	LeaderboardRowHeightCompact
} from "../accessory/accessoryConstants";

const useStyles = createUseStyles({
	rowDivider: {
		width: "100%",
		height: "100%",
		display:"flex",
		flexDirection: "column",
		pointerEvents: "none"
	},
	svg: {
		flex:1
	}
});

export type RowDividerProps = {
	rows?:number
	className?:string
	compact: boolean
}

export default function LeaderboardRowDivider({className, rows, compact}:RowDividerProps) {
	const containerRef = useRef(null);
	const {width=0,height=0} = useDimensionObserver(containerRef);
	const classes = useStyles();

	const strokeWidth = 1;
	const rowHeight = compact ? LeaderboardRowHeightCompact : LeaderboardRowHeight;
	const totalRowHeight = rowHeight + LeaderboardRowGap;
	const rowsFit = Math.floor((height - LeaderboardStartRowY) / totalRowHeight);

	const rowsToDraw = rows ? Math.min(rowsFit, rows) : rowsFit;
	const rowLines = [];
	for(let i = 0; i < rowsToDraw; i++) {
		const y = LeaderboardStartRowY + i * totalRowHeight;
		rowLines.push(<line key={`top${i}`} x1={width-64} y1={y-strokeWidth/2} x2={width} y2={y-strokeWidth/2} stroke={"white"} strokeWidth={strokeWidth} opacity={0.34}/>);
		rowLines.push(<line key={`bot${i}`} x1={width-64} y1={y+rowHeight+strokeWidth/2} x2={width}
							y2={y+rowHeight+strokeWidth/2} stroke={"white"} strokeWidth={strokeWidth} opacity={0.34}/>);
	}


	return (
		<div className={clsx(classes.rowDivider, className)} ref={containerRef}>
			<svg className={classes.svg}>
				<line x1={width-51} y1={0} x2={width-51} y2={height} stroke={"white"} strokeWidth={1} opacity={0.34} />
				<line x1={width-56} y1={0} x2={width-56} y2={height} stroke={"white"} strokeWidth={1} opacity={0.34} />
				<line x1={width-120} y1={25} x2={width} y2={25} stroke={"white"} strokeWidth={1} opacity={0.34} />
				<line x1={88} y1={20} x2={width} y2={20} stroke={"white"} strokeWidth={1} opacity={0.34} />
				<circle cx={84} cy={20} r={4} fill={"white"} opacity={0.34}/>
				{rowLines}
			</svg>
		</div>

	);
}